import { Component, OnInit, AfterViewInit } from '@angular/core';
import { User } from '../../user/user.model';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-external-layout',
  templateUrl: './external-layout.component.html',
  styleUrls: ['./external-layout.component.scss']
})
export class ExternalLayoutComponent implements OnInit, AfterViewInit {

  currentUser: User = new User();

  constructor(private authService: AuthService) { }

  ngOnInit() {
    this.currentUser = this.authService.currentUser;
  }

  ngAfterViewInit() {

    console.log('external view');

    // execute the codebase js scripts
    Codebase.helper('ui-init');
    jQuery('.invisible').delay(10000).removeClass('invisible').fadeIn();

  }

}



// WEBPACK FOOTER //
// ./client/app/core/layout/external/external-layout.component.ts